const { css } = require('styled-components');
const Fonts = require('styles/fonts.json');

exports.text = ({ theme }) => theme.palette?.text?.primary || 'rgba(0, 0, 0, 0.87)';
exports.secondaryText = ({ theme }) => theme.palette?.text?.secondary || 'rgba(0, 0, 0, 0.54)';
exports.paper = ({ theme }) => theme.palette?.background?.paper || '#fff';
exports.divider = ({ theme }) => theme.palette?.divider || 'rgba(0, 0, 0, 0.12)';
exports.primary = ({ theme }) => theme.palette?.primary?.main || '#4611a9';
exports.hover = ({ theme }) => theme.palette?.action?.hover || 'rgba(0, 0, 0, 0.04)';
exports.body = css`
    font-family: ${({ theme }) => theme.typography?.fontFamily || Fonts.copyFont};
    color: ${exports.text};
    font-size: 16px;
    line-height: 1.5;
`;
exports.surface = css`
    ${exports.body}
    border: 1px solid ${exports.divider};
    border-radius: ${({ theme }) => theme.shape?.borderRadius || 10}px;
    background: ${exports.paper};
`;
